<template>
    <div class="block">
        <a href="#" :class="isLoad ? 'title open':'title'" @click.prevent="getEventsEo">Проводимые образовательной организацией в рамках реализации проекта</a>
        <transition name="fade">
        <div class="content" v-if="isLoad">
            <table class="table table-bordered">
                <thead>
                <tr>
                    <th>Название мероприятия</th>
                    <th>Дата проведения</th>
                    <th>Учреждение – соорганизатор мероприятия</th>
                    <th>Целевая аудитория</th>
                    <th>Количество участников</th>
                </tr>
                </thead>
                <tbody v-if="eventsEo">
                    <tr v-bind:key="item.id" v-for="item in eventsEo">
                        <td>{{item.name}}</td>
                        <td :text-content.prop="timestampToDate(item.publish_date)"></td>
                        <td>{{item.co_organization}}</td>
                        <td>{{item.composition}}</td>
                        <td>{{item.amount}}</td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="5">Загрузка данных...</td>
                    </tr>
                </tbody>
            </table>
        </div>
        </transition>
    </div>
</template>

<script>
    import Axios from 'axios'
    import _ from 'lodash'
    import {common} from '../mixins/common'
    export default {
        name: "EventsEo",
        mixins: [common],
        data(){
            return{
                eventsEo: false,
                isLoad: false,
            }
        },
        methods:{
            getEventsEo() {
                if(!this.isLoad && !this.eventsEo){
                    this.isLoad = true
                    const path = this.$store.state.api + this.$store.state.apiEventsEo + "?eoId=" + this.$store.state.eoId
                    const $this = this
                    Axios({
                        method: 'get',
                        url: path
                    }).then((res) => {
                        if (
                            res.status == 200
                            && res.data.result == 'success'
                        ) {
                            $this.eventsEo = _.filter(res.data.data, function (o) {
                                return (
                                    (typeof(o.projectType.altName) !== 'undefined')
                                    && (o.projectType.altName == $this.$store.state.type)
                                )
                            });
                        }
                    })
                }else{
                    this.isLoad = !this.isLoad
                }
            },
        }
    }
</script>

<style scoped>

</style>
